module.exports = __webpack_public_path__ + "media/images/img_top_guide01-09c81a0d4019f52022d6f49f499ae17b.jpg";